import React, { useEffect, useState } from 'react';
import DisplayLongDescriptionAndVariantMFRName from "../../Product/DisplayLongDescriptionAndVariantMFRName";
import Cart from "@system/config/cart";
import Modal from "../Modal";
import noImage from 'src/assets/images/noimage.png'
import { useCartStore } from 'src/hooks/cart';
import Helper from 'src/support/Helper';
import { useNavigate } from 'react-router-dom';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import NavigateToPDP from '../Product/NavigateToPDP';

const AddedToCartNotification = () => {
    const navigate = useNavigate();
    const [status, SetStatus] = useState(false);
    const [{ AddedToCartNotification }, { }, { }] = useDOMAttachToSystemStore();
    const [currentProduct, setCurrentProduct] = useState({});
    const [currentProductCartData, setCurrentProductCartData] = useState({});
    const [{ CART_BEFORE_TO_SEND_SERVER }, { fetch_cart_data }, { }] = useCartStore();
    const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
    const [{ pricingList }, { }, { }] = useProductPricingStore();

    useEffect(() => {
        if (window.location.pathname.includes(Cart.getCartPagePlainRouteURL()) === false && AddedToCartNotification) {
            let p = {};
            try {
                p = AddedToCartNotification.data.server_response.data;
            } catch (e) {
            }
            if (p !== undefined && p.partNumber !== undefined) {
                setCurrentProduct(CART_BEFORE_TO_SEND_SERVER[p.itemNumber])
                setCurrentProductCartData(p)
                addtoCartEvent(p)
            }
            fetch_cart_data({ minicart: true })
            SetStatus(true)
        }
    }, [AddedToCartNotification]);

    const onHide = (action = true) => {
        SetStatus(false);
        document.body.style.overflow = '';
        navigate(-1);
    };

    //By Ramya Kannan [Add to cart - Adobe script ]
    function addtoCartEvent(data) {
        localStorage.setItem("adobeEventType", "addToCartEvent");
        let prodDetails = { ...AddedToCartNotification?.data?.params };
        let serverResponseVal = AddedToCartNotification?.data?.server_response?.data;
        prodDetails.subtotal = serverResponseVal?.subtotal;
        prodDetails.unitPrice = serverResponseVal?.unitPrice;
        prodDetails.qas = getInventory(prodDetails?.ERPPartNumber || prodDetails?.partNumber)?.qas;
        prodDetails.priceSource = getPricing(
            prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
            prodDetails.partNumber || prodDetails.ERPPartNumber,
            prodDetails.ERPPartNumberModified
        )[0]?.priceSource;
        let cartDetails = {
            "additionSource": AddedToCartNotification?.data?.additionSource,
            "cartType": "checkout"
        }
        if (Object.keys(prodDetails).length && Object.keys(cartDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
        }

    }


    //added by Ramya [Adobe script]
    const getInventory = (ERPPartNumber) => {
        return get_inventory_by_id(ERPPartNumber)
    };

    const getPricing = (ERPMFRPartNumber, ERPPartNumber, ERPPartNumberModified) => {
        ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
        if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
            return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
        }
        return [];
    };



    return (
        <>
            <div>
                <Modal show={status} onHide={() => {
                    onHide()
                }}>
                    {currentProductCartData !== undefined &&
                        currentProduct !== undefined &&
                        <div className="avnet-modal modal-680">
                            <div className="avnet-modal-inner">
                                {/* Modal Header */}
                                <button type="button"
                                    onClick={() => {
                                        onHide()
                                    }}
                                    className="close py-3" data-dismiss="modal">×
                                </button>
                                <div className="modal-header justify-content-center mt-0">
                                    <h3 className="pcn-modal-heading pl-5">(1) Item(s) Added to Your Cart</h3>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body mb-4">
                                    <div className="clearfix" />
                                    <div className="add-to-cart-list">
                                        <div className="add-to-cart-item">
                                            <div className="bs5 row m-0">
                                                <div className="col-auto p-0">
                                                    <div className="add-to-cart-item-img">
                                                        <img className="img-fluid"
                                                            src={currentProductCartData.assetURL ? currentProductCartData.assetURL : noImage} />
                                                    </div>
                                                </div>
                                                <div className="col-auto p-0">
                                                    <div className="add-to-cart-item-info">
                                                        <NavigateToPDP data={{
                                                            ManufacturerName: currentProduct?.ManufacturerName,
                                                            ERPMFRPartNumber: currentProduct?.ERPMFRPartNumber,
                                                            ItemNumber: currentProduct?.ItemNumber,
                                                        }}>
                                                            <div className="text-blue">
                                                                <b>{currentProductCartData.erpMfrPartNumber}</b>
                                                            </div>
                                                        </NavigateToPDP>
                                                        <DisplayLongDescriptionAndVariantMFRName
                                                            currentProduct={currentProduct} />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-auto mt-3 mt-sm-0 ms-auto p-0">
                                                    <div className="add-to-cart-price">
                                                        <div className="add-to-cart-price-item">
                                                            <span>Unit Price:</span>
                                                            <b>{Helper.getFormatNumber(Number(currentProductCartData.unitPrice), window.mct, window.mcs, 5)}</b>
                                                        </div>
                                                        <div className="add-to-cart-price-item">
                                                            <span>Quantity:</span>
                                                            <b>{currentProductCartData.quantity}</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-end mt-2 font-12 cart-subtotal">
                                        <span> Item Subtotal ({window.mct}): &nbsp;
                                            <b>
                                                {Helper.getFormatNumber(Number(currentProductCartData.subtotal), window.mct, window.mcs, 2, true, false)}
                                            </b>
                                        </span>
                                    </div>
                                </div>
                                {/* Modal footer */}
                                <div className="modal-footer text-center">
                                    <div className="modal-footer-actions">
                                        <button
                                            onClick={() => {
                                                onHide()
                                            }}
                                            type="button" className="bs5 btn btn-secondary btn-sm w145 px-0"
                                            data-dismiss="modal">
                                            CONTINUE SHOPPING
                                        </button>
                                        <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                            onClick={() => {
                                                window.location.href = Cart.getCartPageRouteURL()
                                            }}
                                            data-dismiss="modal">
                                            VIEW CART
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Modal>
            </div>
        </>
    );
}

export default AddedToCartNotification;